import React from 'react';
import Navbar from '../Nav/Navbar.jsx';
import './About.css';
import Social from '../Socials/Social.jsx';

const About = () => {
  return (
    <div className='container'>
      <Navbar />
      <div className='about-box'>
        <h1 className='about-title'>About This Project :</h1>
        <p className='about-info'>
          Since i like curating maps and creating Data Viz based on it. I
          decided to create an application that will merge my hobby and
          programming which i love{' '}
          <span role='img' aria-label='love'>
            ❤️
          </span>
          .
          <br />
          <br /> So this Map-Quiz has 150+ Maps excluding the Islands nations as
          curating it is hard. Currently working on adding smaller maps like
          Singapore , Hongkong etc. Maps are based on{' '}
          <span className='highlight'>Mercator projection</span> and{' '}
          <span className='highlight'>Robinson projection</span>
          <br />
          <br />
          P.S : Maps layouts aren't exact or for scale they have been scaled
          down for optimization and performance purposes.
          <br /> There's 5+ more Games , Quiz-Based Applications Completed yet
          to be Public (Hopefully soon ..😁).
        </p>
        <p className='about-info'>
          <span className='about-updates'>Updates :</span>
          <li>Fix in React-Client-Side Routing Error</li>
          <li>Optimizing SVGs from 1,243 KB -&#62; to 578 KB -&#62; 539 KB</li>
          <li>Added Wrong Selection and Restrictions</li>
          <li>Validations | Top100 LeaderBoards</li>
          <span className='about-updates'>For Bugs :</span>
          <li>
            Contact at{' '}
            <a href='https://www.instagram.com/maps_affinity/'>
              @maps_affinity
            </a>
            .{' '}
          </li>
        </p>
      </div>
      <div className='about-box'>
        <h1 className='about-title'>About Me :</h1>
        <p className='about-info'>
          19yo Programmer , Map Curator and Creator of{' '}
          <a href='https://www.instagram.com/maps_affinity/'>@maps_affinity</a>.{' '}
          I love SVGs over PNGs , ReactJS over AngularJS , FCPX over Adobe AE.
        </p>
        <p className='about-info'>Currently Learning GraphQL , NextJS</p>
        <p className='about-info'>
          Some of my Projects can be found on my{' '}
          <a href='https://github.com/Deep-Codes'>Github Profile</a> and many
          would be publicly visible in some span of time. So do Check it Out!
        </p>
        <p className='about-info'>That's It.</p>
      </div>
      <div className='about-box'>
        <h1 className='about-title'>Some Quotes:</h1>
        <p className='about-info'>
          "Remember the best time to plant a tree was 10 years ago and the
          second best time is now. Just start learning"
        </p>
        <p className='about-info'>
          "Writing bad code is a prerequisite to writing good code"
        </p>
        <p className='about-info'>
          "If you are struggling to learn how to code it's probably because
          you're not coding enough"
        </p>
      </div>
      <Social />
    </div>
  );
};

export default About;
